import React from 'react';

import { Grid, Link, MarkdownFormatter, SxProps, Typography } from '@methanesat/ui-components';

interface MoreInfoSectionProps {
    header?: string;
    content?: string;
    sx?: SxProps;
}

/**
 * This component is used in the dispersed source and point source drawers to give the user more information about the data type they've clicked on.
 */
export const MoreInfoSection = ({ header, content, sx }: MoreInfoSectionProps) => {
    return (
        <Grid container sx={[{ marginTop: 1.5 }, ...(Array.isArray(sx) ? sx : [sx])]}>
            {header && (
                <Grid size={{ xs: 12 }}>
                    <Typography variant="h4" sx={{ '&.MuiTypography-h4': { fontSize: '1.1rem' } }}>
                        {header}
                    </Typography>
                </Grid>
            )}
            {content && (
                <Grid size={{ xs: 12 }} marginTop={1}>
                    {content.split(/\n\s*\n/).map((block, i, arr) => (
                        <Typography
                            key={i}
                            variant="body1"
                            component="div"
                            sx={{ marginBottom: i === arr.length - 1 ? 0 : 2 }}
                        >
                            <MarkdownFormatter
                                components={{
                                    a({ href, children }) {
                                        return (
                                            <Link
                                                href={href}
                                                target="_blank"
                                                underline="always"
                                                data-testid="more-info-link"
                                            >
                                                {children}
                                            </Link>
                                        );
                                    }
                                }}
                                markdown={block}
                            />
                        </Typography>
                    ))}
                </Grid>
            )}
        </Grid>
    );
};
